import React from 'react';
import SEO from './components/SEO';
import PlaylistViewer from './components/PlaylistViewer';

const mediaPlaylists = [
  {
    title: 'English Songs',
    id: 'PLlfpe0DDwzp2X5o3br_eDTp-rU_yFhGP2',
    description: 'Top trending English songs.',
  },
  {
    title: 'Tamil Songs',
    id: 'PLlfpe0DDwzp065euqYHzQM7S1X222WsmZ',
    description: 'Enjoy the best Tamil songs.',
  },
  {
    title: 'Malayalam Songs',
    id: 'PLlfpe0DDwzp2Lcv9lxQywvfim0HYTkGps',
    description: 'A collection of popular Malayalam songs.',
  },
  {
    title: 'Bible Melodies',
    id: 'PLlfpe0DDwzp2sPVR-C3TnlANlB3FhqqwU',
    description: 'Bible Melodies - Worship & Learn.',
  },
  {
    title: 'Bible Songs Jukebox',
    id: 'PLlfpe0DDwzp0ldn0ZnLBal-M_S8GVZdP6',
    description: 'Bible Songs Jukebox: Worship & Learn',
  },
];

export default function Song() {
  return (
    <>
      <SEO
        title="Songs"
        description="Curated worship song playlists from GCC."
      />
      <PlaylistViewer
        pageTitle="Songs"
        playlists={mediaPlaylists}
        showPageTitle={false}
      />
    </>
  );
}
